import React, { useEffect, useState } from 'react'
import { Breadcrumb, Button, Container, Form, Table } from 'react-bootstrap'

import { Entitlement } from 'interfaces/entitlement'
import { useEntitlements } from 'hooks/use-entitlements'
import useCreateEntitlementGrouping from 'hooks/use-create-entitlement-grouping'
import { useHistory } from 'react-router-dom'

const CreateEntitlementGroupingPage = () => {
  const history = useHistory()
  const [entitlementGroupingName, setEntitlementGroupingName] = useState('')
  const [entitlements, setEntitlements] = useState<Entitlement[]>([])
  const { data: entitlementsData, isFetching } = useEntitlements()
  const createEntitlementGrouping = useCreateEntitlementGrouping()

  useEffect(() => {
    setEntitlements(entitlementsData || [])
  }, [entitlementsData])

  const handleSaveClick = () => {
    const entitlementIds: number[] = []
    entitlements.forEach((entitlement) => {
      if (entitlement.enabled) {
        entitlementIds.push(entitlement.id)
      }
    })
    if (entitlementGroupingName === '') {
      alert('Please enter entitlement grouping name')
      return
    }
    if (entitlementIds.length === 0) {
      alert('Please select at least one entitlement')
      return
    }
    createEntitlementGrouping.mutate(
      {
        entitlement_ids: entitlementIds,
        title: entitlementGroupingName,
      },
      {
        onSuccess: (data) => {
          history.push(`/entitlement-groupings/${data.id}`)
        },
      }
    )
  }

  return (
    <Container>
      <Breadcrumb>
        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
        <Breadcrumb.Item href="/entitlement-groupings">
          Entitlement Groupings
        </Breadcrumb.Item>
        <Breadcrumb.Item active>Entitlement Grouping</Breadcrumb.Item>
      </Breadcrumb>
      {isFetching ? (
        <h3>Loading...</h3>
      ) : (
        <>
          <Button onClick={handleSaveClick} variant="success" className="mb-4">
            Save
          </Button>

          <Form className="mt-4 mb-4">
            <Form.Group className="mb-3">
              <Form.Label>Entitlement Grouping Name</Form.Label>
              <Form.Control
                autoComplete="off"
                type="text"
                value={entitlementGroupingName}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setEntitlementGroupingName(event.target.value)
                }}
                placeholder="Enter entitlement grouping name here........."
              />
            </Form.Group>
          </Form>
          <Table striped bordered hover responsive variant="dark">
            <thead>
              <tr>
                <th>Name</th>
                <th>Select Entitlement</th>
              </tr>
            </thead>
            <tbody>
              {isFetching ? (
                <tr>
                  <td>Loading...</td>
                </tr>
              ) : (
                entitlements?.map((entitlement, index) => (
                  <tr key={entitlement.id}>
                    <td>{entitlement.title}</td>
                    <td>
                      <input
                        key={`${entitlement.id}-enabled`}
                        className="form-check-input"
                        type="checkbox"
                        checked={entitlement.enabled}
                        onChange={(e) => {
                          const newEntitlements = entitlements.map(
                            (entity, i) => {
                              if (index === i) {
                                return { ...entity, enabled: e.target.checked }
                              }

                              return entity
                            }
                          )
                          setEntitlements(newEntitlements)
                        }}
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </>
      )}
    </Container>
  )
}

export default CreateEntitlementGroupingPage
